export default {
  video: {
    desc: 'あなたの安全な暗号資産ハードウェアウォレット',
    preOrderNow: '購入',
    watchNow: '今すぐ見る',
  },

  introduce: {
    title:
      'KeyPal — 安全性と使いやすさを兼ね備え、その優位性を余すところなく発揮',
    desc_1: '任意のカードをクリックして詳細を確認',
    desc_2: '接続',
    desc_3: 'セキュリティ',
    desc_4: 'バックアップ',
    desc_5: 'パスフレーズ',
    desc_6: 'バッテリ',
    desc_7: '持続時間',
    desc_8: 'デュアルチップ',
    desc_9: '15キー配列',
    desc_10: '多様な接続方法から、あなたにぴったりのものが見つかります',
    desc_11: 'NFC + KeyPal Card',
    desc_12: '使用',
    label_1:
      'BluetoothおよびQRコードスキャンによるウォレット接続と取引署名に対応',
    label_1_1:
      '利用シーンに応じて接続方法を選択でき、ハードウェアウォレットの使用をより安全かつ便利にします',
    label_2: 'KeyPal 2はPassphraseに対応しています',
    label_2_1:
      '同じ復元フレーズでも、異なるPassphraseを使用することで別々のウォレットにアクセスでき、ウォレットにさらなるセキュリティを追加します',
    label_3: 'NFCに対応し、より簡単かつ高速なバックアップを実現',
    label_3_1:
      'KeyPal 2はNFCを利用して、復元フレーズをKeyPal Cardに素早くバックアップできます',
    label_4: 'バッテリー容量が大きくなり、300 mAhから500 mAhにアップグレード',
    label_4_1:
      '1回の充電で最大12時間連続稼働し、バッテリー切れの不安から解放します',
    label_5: 'KeyPal 2は軍用レベルのデュアルチップ設計を採用',
    label_5_1: 'MCU＋SE構成で、安全性はコアから始まります',
    label_6: '15キーグリッドで入力と操作がより簡単に',
    label_6_1: 'コンテンツ入力や機能選択を素早く行え、長く複雑な手順は不要です',
  },

  support: {
    title: '数百万種類の暗号資産に対応',
    desc_1: '対応リストを表示',
  },

  other: {
    title: 'その他の KeyPal 製品',
    desc_1: `KeyPal Plus はデュアルチップ構造を採用し、使いやすさと安全性を兼ね備えています。ミニマルなデザインスタイルと頑丈なアルミ合金製シェルを組み合わせ、耐久性と効率性を両立したデジタル資産管理体験を提供します`,
    desc_2: `KeyPal Card は NFC 通信に対応し、ワンタップでニーモニックフレーズや秘密鍵を簡単に保存できます。オフラインバックアップと署名機能を完璧に組み合わせています。クレジットカードサイズのデザインで、持ち運びやすく安全に、いつでもどこでも暗号資産を保護します`,
    desc_3: `KeyPal Card는 NFC 통신을 지원하며, 한 번의 터치로 니모닉 문구와 개인 키를 손쉽게 저장할 수 있습니다. 오프라인 백업과 서명 기능을 완벽하게 결합하였습니다. 신용카드 크기의 디자인으로 휴대가 간편하고 안전하여 언제 어디서나 암호화 자산을 보호합니다.`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: 'クリックしてすべてのFAQの回答を表示',
    question_1: '暗号ウォレットとは？',
    question_2: 'なぜハードウェアウォレットが必要ですか？',
    question_3: 'ハードウェアウォレットとアプリウォレットの違いは？',
    question_4: 'もしデバイスを失くしたら、資産は安全ですか？',
    question_5:
      'KeyPal ハードウェアウォレットはどんな暗号資産をサポートしていますか？',
  },

  discover: {
    title: 'お好みの KeyPal カラーをお選びください',
    desc_1: '発見',
  },

  instructions: {
    title: 'チュートリアルセンター',
    desc: '包括的なデモンストレーションで KeyPal 2 を簡単に学び、暗号資産管理をシンプルかつ安全にします。',
    tabs: {
      hardware: 'デバイス機能',
      activation: 'デバイスチュートリアル',
      connect: 'ウォレット接続',
      upgrade: 'ファームウェア更新',
    },
    hardware: {
      basic: '基本操作',
      power: '電源オン/オフ',
      language: '言語選択',
      button: 'ボタン操作',
      features: '機能紹介',
      security: 'セキュリティ設定',
      passphrase: 'パスフレーズ設定',
      securityOverview: 'セキュリティ設定概要',
      verifyDevice: 'デバイスを検証',
      asset: '資産管理',
    },
    activation: {
      create: 'リカバリーフレーズ作成',
      createByDevice: 'デバイスでフレーズ生成',
      import: 'フレーズ導入',
      manualImport: '手動導入',
      keypalCardImport: 'KeyPal Card 経由導入',
      backup: 'フレーズバックアップ',
      steelBackup: '書き写し/金属バックアップ',
      keypalCardBackup: 'KeyPal Card バックアップ',
    },
    connect: {
      bluetooth: 'Bluetooth TokenPocket 接続',
      connectAndAdd: 'アプリ接続とアドレス追加',
      qrConnect: 'QR 接続',
      qrConnectTP: 'TokenPocket QR 接続',
      qrConnectMM: 'MetaMask QR 接続',
      transferReceive: '送金と受取',
      receiveHardware: 'ハードウェアで受取',
      receiveApp: 'アプリで受取',
      transfer: '送金',
    },
    upgrade: {
      web: 'Web ページで更新',
      bluetooth: 'Bluetooth で更新',
      mobile: 'モバイルで更新',
      troubleshoot: '更新トラブル対策',
      webTroubleshoot: 'Web ページ更新トラブル対策',
      bluetoothTroubleshoot: 'Bluetooth 更新トラブル対策',
    },
    relatedVideos: '関連動画',
    playing: '再生中',
  },
};
